var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOfcCable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-OFC_Cable"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "OFC_Cable",
    "data-name": "OFC Cable",
    clipPath: "url(#clip-OFC_Cable)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "wire",
    transform: "matrix(0.545, 0.839, -0.839, 0.545, 314.079, -124.585)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_181",
    "data-name": "Group 181",
    transform: "translate(199.12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_305",
    "data-name": "Path 305",
    d: "M220.885,106.105a10.671,10.671,0,0,1-10.492-8.82L199.284,34.264a10.665,10.665,0,1,1,21.007-3.7L231.4,93.582a10.668,10.668,0,0,1-8.647,12.359A10.872,10.872,0,0,1,220.885,106.105Z",
    transform: "translate(-199.12)",
    fill: "#434a54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_306",
    "data-name": "Path 306",
    d: "M291.1,106.105a10.851,10.851,0,0,1-1.859-.164,10.656,10.656,0,0,1-8.656-12.359L291.7,30.561a10.669,10.669,0,1,1,21.014,3.7L301.584,97.285A10.655,10.655,0,0,1,291.1,106.105Z",
    transform: "translate(-135.995)",
    fill: "#434a54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_307",
    "data-name": "Path 307",
    d: "M255.992,85.324A10.662,10.662,0,0,1,245.328,74.66v-64a10.665,10.665,0,0,1,21.329,0v64A10.662,10.662,0,0,1,255.992,85.324Z",
    transform: "translate(-167.56)",
    fill: "#434a54"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_308",
    "data-name": "Path 308",
    d: "M293.164,320.971,252.414,89.879a10.667,10.667,0,0,0-12.359-8.648l-42.014,7.406A10.658,10.658,0,0,0,189.385,101L230.134,332.08a10.655,10.655,0,0,0,10.491,8.812,10.923,10.923,0,0,0,1.867-.156l42.015-7.406a10.67,10.67,0,0,0,8.657-12.359Z",
    fill: "#4a89dc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309",
    "data-name": "Path 309",
    d: "M320.834,93.019a10.675,10.675,0,0,0-6.891-4.382L271.93,81.231a10.668,10.668,0,0,0-12.359,8.648L218.822,320.971a10.685,10.685,0,0,0,8.655,12.359l42.015,7.406a10.923,10.923,0,0,0,1.867.156,10.668,10.668,0,0,0,10.491-8.812L322.6,101A10.7,10.7,0,0,0,320.834,93.019Z",
    transform: "translate(63.125)",
    fill: "#da4453"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_310",
    "data-name": "Path 310",
    d: "M298.647,236.771V85.942L271.93,81.231a10.668,10.668,0,0,0-12.359,8.648L234.657,231.17v78.146a10.675,10.675,0,0,0,10.671,10.671h38.664Z",
    transform: "translate(41.24)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_311",
    "data-name": "Path 311",
    d: "M252.414,89.879a10.667,10.667,0,0,0-12.359-8.648L213.33,85.942v150.83L228,319.988h38.656a10.678,10.678,0,0,0,10.68-10.671V231.17Z",
    transform: "translate(21.887)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_312",
    "data-name": "Path 312",
    d: "M277.337,64h-42.68a10.662,10.662,0,0,0-10.663,10.664V309.317a10.669,10.669,0,0,0,10.663,10.671h42.68a10.672,10.672,0,0,0,10.655-10.671V74.66A10.665,10.665,0,0,0,277.337,64Z",
    transform: "translate(31.565)",
    fill: "#a0d468"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_313",
    "data-name": "Path 313",
    d: "M367.206,213.32c-6.019,0-11.269,2.234-14,5.539-3.733,1.312-18.71,5.125-65.651,5.125s-61.906-3.812-65.663-5.125c-2.718-3.3-7.956-5.539-13.975-5.539-8.795,0-15.923,4.773-15.923,10.664V490.638a7.46,7.46,0,0,0,.163,1.515c.7,3.3,4.339,9.484,20.8,13.766,15.432,4.031,40.536,6.062,74.6,6.062s59.168-2.031,74.61-6.062c16.447-4.281,20.086-10.469,20.787-13.766a6.7,6.7,0,0,0,.163-1.515V223.984C383.116,218.093,375.977,213.32,367.206,213.32Z",
    transform: "translate(0)",
    fill: "#434a54"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_182",
    "data-name": "Group 182",
    transform: "translate(308.452 213.32)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_314",
    "data-name": "Path 314",
    d: "M309.335,213.32a10.707,10.707,0,0,0-9.375,5.539,16.428,16.428,0,0,1-2.172.914,10.55,10.55,0,0,1,.859,4.211V490.638a12.217,12.217,0,0,1-.094,1.515c-.469,3.3-2.9,9.484-13.937,13.766-8.655,3.375-21.843,5.344-39.289,5.906,3.391.094,6.945.156,10.664.156,22.813,0,39.625-2.031,49.967-6.062,11.015-4.281,13.452-10.469,13.921-13.766a9.89,9.89,0,0,0,.109-1.515V223.984A10.662,10.662,0,0,0,309.335,213.32Z",
    transform: "translate(-245.327 -213.32)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfcCable);
export default __webpack_public_path__ + "static/media/OFC Cable.90f5aedd95f9aa71f694e95b38ce6f44.svg";
export { ForwardRef as ReactComponent };